import React, { Component } from 'react';
import ProductSlider from './productSlider';
import ReactGA from 'react-ga4';

class ProductDetail extends Component {

    constructor(props) {
		super(props);
		this.state = {
			opened: false,
            message: '',
		};
		this.toggleBox = this.toggleBox.bind(this);
	}

    state = { }

    toggleBox(value,url) {
        
        // TRACKING
        if (!this.state.opened){
            // console.log('item_name: ' + value);
            // console.log('item_id: ' + url);
            // console.log('cta_type: share');
            ReactGA.event('product_finder_cta_click', {
                'item_name': value,
                'item_id': url,
                'cta_type': 'share',
            });
        }
        

		const { opened } = this.state;
		this.setState({
			opened: !opened,
		});
    }

    copyUrl = () => {
        navigator.clipboard.writeText(window.location.protocol + '//' + window.location.host + window.location.pathname + '?a=' + this.props.aUid + '&p=' + this.props.item.product.uid)
        this.setState({
            message: this.props.appData.productfinder_share_message_copied
        })
        setTimeout(() => {
            this.setState({ message: '' });
        }, 1000);
    }

    ctaClick(value,url,type) {
        // TRACKING
        // console.log('item_name: ' + value);
        // console.log('item_id: ' + url);
        // console.log('cta_type: ' + type);
        ReactGA.event('product_finder_cta_click', {
            'item_name': value,
            'item_id': url,
            'cta_type': type,
        });
    }

    render() { 
        return (
            <div className="row">                
                <div className='col-md-4 col-lg-3 detail-img'>
                    <div className='inner'>
                        {this.props.item.label.length
                            ? <div className='label'>{this.props.item.label}</div>
                            : ''
                        }
                        <img src={this.props.item.product.image} className="card-img-top" alt="..." />
                    </div>
                </div>
                <div className='col-md-8 col-lg-9'>
                    <h2>{this.props.item.product.title}</h2>
                    <div className='shortDescription'>
                        {this.props.item.product.shortDescription}
                    </div>
                    <div className='certifications row'>
                        {this.props.item.product.certificateImages ? (
                            <>
                            {this.props.item.product.certificateImages.map((item, index) => (
                                <div key={index} className='col item'>
                                    <div className='inner'>
                                        <img src={item} className="certificateImage" alt="..." />
                                    </div>
                                </div>
                            ))}
                            </>
                            ) : ''
                        }
                    </div>
                    <div className='advantages row'>
                        {this.props.item.product.advantages.map((item, index) => (
                            index <= '2'
                            ? (
                                <div key={index} className='col item'>
                                    <div className='inner'>
                                        {item}
                                    </div>
                                </div>
                            ) : null
                        ))}
                    </div>
                </div>
                <div className='col-12 buttons'>
                    {this.props.item.contentLink 
                        ? <><a className="btn btn-secondary cta" href={this.props.item.contentLink.url} onClick={() => this.ctaClick(this.props.appData.productfinder_detail_btnContent,this.props.item.contentLink.url,'contentLink')} target="_blank" rel="noreferrer">{this.props.appData.productfinder_detail_btnContent}</a></>
                        : (
                            <>
                            {this.props.item.product.productContentLink 
                                ? <><a className="btn btn-secondary cta" href={this.props.item.product.productContentLink.url} onClick={() => this.ctaClick(this.props.appData.productfinder_detail_btnContent,this.props.item.product.productContentLink.url,'productContentLink')} target="_blank" rel="noreferrer">{this.props.appData.productfinder_detail_btnContent}</a></>
                                : ''
                            }
                            </>
                        )
                    }
                    {this.props.item.product.link 
                        ? (
                            <>
                                {this.props.item.product.isProductSystem
                                    ? <><a className="btn btn-secondary cta" onClick={() => this.ctaClick(this.props.appData.productfinder_detail_btnSystem,this.props.item.product.link,'system')} href={this.props.item.product.link} target="_blank" rel="noreferrer">{this.props.appData.productfinder_detail_btnSystem}</a></>
                                    : <><a className="btn btn-secondary cta" onClick={() => this.ctaClick(this.props.appData.productfinder_detail_btnProduct,this.props.item.product.link,'product')} href={this.props.item.product.link} target="_blank" rel="noreferrer">{this.props.appData.productfinder_detail_btnProduct}</a></>
                                }
                            </>
                        )
                        : ''
                    }
                    {this.props.result.specialistDealerSearchUrl 
                        ? <a className="btn btn-secondary cta" href={this.props.result.specialistDealerSearchUrl} onClick={() => this.ctaClick(this.props.appData.productfinder_detail_btnSpecialistDealer,this.props.result.specialistDealerSearchUrl,'specialistDealer')} target="_blank" rel="noreferrer">{this.props.appData.productfinder_detail_btnSpecialistDealer}</a>
                        : ''
                    }
                    {this.props.result.contactFormUrl 
                        ? <a className="btn btn-secondary cta" href={this.props.result.contactFormUrl} onClick={() => this.ctaClick(this.props.appData.productfinder_detail_btnContact,this.props.result.contactFormUrl,'contact')} target="_blank" rel="noreferrer">{this.props.appData.productfinder_detail_btnContact}</a>
                        : ''
                    }
                    <div className='share'>
                    {this.state.opened
                            ? (
                                <>
                                <div className='div-shadow'></div>
                                <div className='share-content'>
                                    <div className=''>
                                        <b>{this.props.appData.productfinder_share}</b>
                                        <div onClick={this.toggleBox} className='close'></div>
                                    </div>
                                    <a className='mail' href={`mailto:?subject=${this.props.appData.productfinder_share_email_subject}&body=${this.props.appData.productfinder_share_email_body}%0A ${window.location.protocol}//${window.location.host}${window.location.pathname}?a=${this.props.aUid}%26p=${this.props.item.product.uid}`}>
                                    {this.props.appData.productfinder_share_email}
                                    </a>
                                    <span className='copy' onClick={this.copyUrl}>
                                    {this.props.appData.productfinder_share_url_copy}
                                    </span>
                                    {this.state.message
                                        ? <span className='message'>{this.state.message}</span>
                                        : ''
                                    }
                                </div>
                                </>
                            )
                            : ''
                        }
                        <button onClick={() => this.toggleBox(this.props.appData.productfinder_share_btn,`${window.location.protocol}//${window.location.host}${window.location.pathname}?a=${this.props.aUid}%26p=${this.props.item.product.uid}`)} className="btn btn-brand btn-share">
                            <svg fill="#FFFFFF" className='svg-icon' version="1.1" id="Capa_1" viewBox="0 0 481.6 481.6">
                                <g>
                                    <path d="M381.6,309.4c-27.7,0-52.4,13.2-68.2,33.6l-132.3-73.9c3.1-8.9,4.8-18.5,4.8-28.4c0-10-1.7-19.5-4.9-28.5l132.2-73.8
                                        c15.7,20.5,40.5,33.8,68.3,33.8c47.4,0,86.1-38.6,86.1-86.1S429,0,381.5,0s-86.1,38.6-86.1,86.1c0,10,1.7,19.6,4.9,28.5
                                        l-132.1,73.8c-15.7-20.6-40.5-33.8-68.3-33.8c-47.4,0-86.1,38.6-86.1,86.1s38.7,86.1,86.2,86.1c27.8,0,52.6-13.3,68.4-33.9
                                        l132.2,73.9c-3.2,9-5,18.7-5,28.7c0,47.4,38.6,86.1,86.1,86.1s86.1-38.6,86.1-86.1S429.1,309.4,381.6,309.4z M381.6,27.1
                                        c32.6,0,59.1,26.5,59.1,59.1s-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1S349.1,27.1,381.6,27.1z M100,299.8
                                        c-32.6,0-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1S132.5,299.8,100,299.8z M381.6,454.5
                                        c-32.6,0-59.1-26.5-59.1-59.1c0-32.6,26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1C440.7,428,414.2,454.5,381.6,454.5z" />
                                </g>
                            </svg>
                            {this.props.appData.productfinder_share_btn}
                        </button>
                        
                    </div>
                    
                </div>
                
                {this.props.item.product.relatedProducts.length && this.props.item.product.isProductSystem
                    ? <ProductSlider products={this.props.item.product.relatedProducts} appData={this.props.appData} />
                    : ''
                }

            </div>
        );
    }
}
 
export default ProductDetail;